import { render, staticRenderFns } from "./DLogo.vue?vue&type=template&id=7990cc23&scoped=true"
import script from "./DLogo.vue?vue&type=script&lang=js"
export * from "./DLogo.vue?vue&type=script&lang=js"
import style0 from "./DLogo.vue?vue&type=style&index=0&id=7990cc23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990cc23",
  null
  
)

export default component.exports